import _ from "lodash";

var TreeOption = /*#__PURE__*/function () {
  function TreeOption(raw, isEnd) {
    _.merge(this, raw);

    this.isEnd = isEnd;
  }

  var _proto = TreeOption.prototype;

  _proto.withParent = function withParent(parent) {
    this.parent = parent;
    return this;
  };

  _proto.withChildren = function withChildren(children) {
    var _this$children;

    (_this$children = this.children).push.apply(_this$children, children);

    return this;
  };

  _proto.getParentValues = function getParentValues(values) {
    if (values === void 0) {
      values = [this.id];
    }

    if (this.parent) {
      var parentValue = this.parent.id;
      return this.parent.getParentValues([parentValue].concat(values));
    }

    return values;
  };

  return TreeOption;
}();

export default TreeOption;